
import "/Users/yingben001/IdeaProjects/edatlink-box-admin/src/pages/ISWAN_CHAT/components/AISelectMenu/index.less?modules";
export default {"label": `label-M48SmPvV`,"tag": `tag-6c_5baL6`,"itemActive": `itemActive-st6ls5H0`,"hoverBg": `hoverBg-dvajNFDQ`,"main": `main-6ZY7b31H`,"item": `item-PLrqHKGK`,"icon": `icon-Ewl2aTj9`}
